import React from 'react';

const ProductsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path d="M0 0H6.125V6.125H0V0ZM7.875 0H14V6.125H7.875V0ZM0 7.875H6.125V14H0V7.875ZM7.875 7.875H14V14H7.875V7.875Z" fill="currentColor"/>
  </svg>
);

export default ProductsIcon;